export default class OverlayView extends window.google.maps.OverlayView {
  position = null;

  content = null;

  constructor(props: any) {
    super(props);
    this.position = props.position || this.position;
    this.content = props.content || this.content;
  }

  /** Called when the popup is added to the map. */
  onAdd = () => {
    const panes = this.getPanes();
    if (panes) panes.floatPane.appendChild(this.content);
  };

  /** Called when the popup is removed from the map. */
  onRemove = () => {
    if (this.content.parentElement) {
      this.content.parentElement.removeChild(this.content);
    }
  };

  /** Called each frame when the popup needs to draw itself. */
  draw = () => {
    const divPosition = this.getProjection().fromLatLngToDivPixel(
      this.position
    );
    this.content.style.left = `${divPosition.x}px`;
    this.content.style.top = `${divPosition.y}px`;
  };
}
